function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M0 0h110.37v110.37H0z"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M46.516 82.722h10.819V96.26H46.516zm10.5-7.834h-10.18V66.68q0-5.382 1.493-8.846t6.288-8.048l4.797-4.743q3.037-2.825 4.37-5.33 1.385-2.504 1.385-5.116 0-4.743-3.517-7.674-3.464-2.932-9.22-2.932-4.21 0-9.007 1.866-4.743 1.865-9.913 5.436v-10.02q5.01-3.037 10.125-4.53 5.17-1.492 10.66-1.492 9.806 0 15.721 5.17 5.97 5.17 5.97 13.643 0 4.05-1.92 7.728Q72.15 45.416 67.355 50l-4.69 4.583q-2.505 2.505-3.57 3.944-1.013 1.386-1.44 2.718-.32 1.12-.48 2.718t-.16 4.37z",
  fill: "#fff",
  "aria-label": "?"
});

function SvgUnknownTypeArtifact(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 417.146,
    height: 417.146,
    viewBox: "0 0 110.369 110.369"
  }, props), _ref, _ref2);
}

export default __webpack_public_path__ + "unknown-type-artifact.2d7bb.svg";
export { SvgUnknownTypeArtifact as ReactComponent };